<template>
  <div v-if="lots.loading" class="ta-lot-list" :class="['view-type-' + (lotListViewType)]">
    <div v-for="(el, i) in skeletonNumbers" v-bind:key="`skeleton-${i}`" class="mb-2">
      <slot name="item-skeleton">
        <lot-list-item-skelleton />
      </slot>
    </div>
  </div>
  <div v-else-if="lots.results.length" class="ta-lot-list-items" :key="lots.hash">
    <offline-message />
    <div class="ta-lot-list" :class="['view-type-' + (lotListViewType)]">
      <lot-list-item v-for="lot in lots.results" :key="lot.uuid + lot.hash" :lot="lot">
      </lot-list-item>
      <template v-if="loadingNewItems">
        <div v-for="(el, i) in skeletonNumbers" v-bind:key="`skeleton-${i}`" class="mb-2">
          <slot name="item-skeleton">
            <lot-list-item-skelleton />
          </slot>
        </div>
      </template>
    </div>
    <lot-list-load-more @startFetchingLots="updateFetchingLots(true)" @stopFetchingLots="updateFetchingLots(false)"/>
    <lot-list-load-on-scroll @startFetchingLots="updateFetchingLots(true)" @stopFetchingLots="updateFetchingLots(false)" />
    <div v-if="isPagingTypePagination" class="ta-lot-list-footer">
      <lot-list-pagination-summary/>
      <lot-list-pagination-buttons/>
    </div>
  </div>
  <div v-else>
    <p class="ta-no-lots-text">
      {{ $t('There are no lots') }}
    </p>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import LotListItem from "../../LotListItem";
import LotListLoadMore from "./LotListLoadMore";
import lotAuctionListMixin from "@/mixins/lotAuctionListMixin";
import OfflineMessage from "@/components/OfflineMessage.vue";
import LotListLoadOnScroll from "@/components/configuration/lot-list/LotListLoadOnScroll.vue";
import LotListItemSkelleton from "@/components/LotListItemSkelleton.vue";

export default {
  name: "LotListItems",
  components: {LotListItemSkelleton, LotListLoadOnScroll, OfflineMessage, LotListLoadMore, LotListItem},
  mixins: [lotAuctionListMixin('LotListItems')],
  data: () => ({
    loadingNewItems: false
  }),
  computed: {
    ...mapGetters(['lots']),
    ...mapState(['lotListViewType', 'lotQueryParams']),
    ...mapState({
      contentLoaded: state => state.lots.loaded // Necessary for mixin
    }),
    ...mapGetters(['isPagingTypeLoadMore', 'isPagingTypePagination']),
    skeletonNumbers() {
      let tmp = this.lots.totalRows - this.lots.results.length;
      if (tmp === 0) {
        tmp = Number.MAX_SAFE_INTEGER;
      }

      return Array.from({length: Math.min(this.lotQueryParams.limit, tmp)})
    }
  },
  methods: {
    updateFetchingLots(val) {
      this.loadingNewItems = val;
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../bootstrap/import.scss";
@import "../../../scss/mixins";

.ta-no-lots-text {
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  color: $gray-600
}

.ta-lot-list {
  display: grid;
  grid-template-columns: 1fr;
  overflow: auto;
  @include scrollbars();

  &.view-type-grid {
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 1rem;
    row-gap: 1rem;
  }
}

.ta-lot-list-items {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

@include media-breakpoint-down(xl) {
  .ta-lot-list.view-type-grid {
    grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
  }
}

@include media-breakpoint-down(md) {
  .ta-lot-list {
    flex-direction: column;
  }
}

@include media-breakpoint-down(xs) {
  .ta-lot-list {
    column-gap: 1rem;
    row-gap: 1rem;
  }
}
</style>
